/* Mirra Masa — Add to Bag reference-video loading state (draft).
   Observer only. The original theme still submits to Shopify and owns cart UI.
   A successful response to /cart/add(.js) ends loading; no fake success timer. */
(function () {
  'use strict';
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {once:true});
  } else {
    init();
  }

  function init() {
    if (!document.body || !document.body.classList.contains('template-product')) return;
    if (window.__mmReferenceCartEffect) return;
    window.__mmReferenceCartEffect = true;

    var current = null;
    var originalFetch = window.fetch;
    var originalOpen = window.XMLHttpRequest.prototype.open;
    var originalSend = window.XMLHttpRequest.prototype.send;

    function cartAddUrl(value) {
      try {
        var path = new URL(String(value && value.url ? value.url : value), location.href).pathname;
        return /\/cart\/add(?:\.js)?\/?$/i.test(path);
      } catch (e) { return false; }
    }
    function controls(form) {
      var main = form.querySelector('button[data-atc-form].t4s-product-form__submit');
      var result = main ? [main] : [];
      var owner = form.closest('.t4s-product-form__variants');
      var sticky = owner && owner.querySelector('.mm-mobile-sticky-atc button');
      if (sticky) result.push(sticky);
      return result;
    }
    function enabled(form) {
      var button = form && form.querySelector('button[data-atc-form].t4s-product-form__submit');
      if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return false;
      if (form.classList.contains('mm-size-selection-pending')) return false;
      // Maintains the previously approved explicit size/color selection behavior.
      var sizeToggle = form.querySelector('.mm-size-select__toggle');
      if (sizeToggle) {
        var choice = form.querySelector('.mm-size-select__chosen');
        if (!choice || choice.textContent.trim().toLowerCase() === 'select a size') return false;
      }
      var groups = form.querySelectorAll('.t4s-swatch__option.is-t4s-style__color');
      for (var i=0;i<groups.length;i++) {
        var swatches=groups[i].querySelectorAll('[data-swatch-list] > [data-swatch-item].is-sw__color');
        if (swatches.length > 1 && !groups[i].querySelector('[data-swatch-list] > [data-swatch-item].mm-swatch-clicked')) return false;
      }
      return true;
    }
    function status(button) {
      var s = button.querySelector('.mm-atc-status');
      if (!s) {
        s=document.createElement('span');
        s.className='mm-atc-status';
        s.setAttribute('role','status');
        s.setAttribute('aria-live','polite');
        button.appendChild(s);
      }
      return s;
    }
    function start(form) {
      if (current || !enabled(form)) return;
      var buttons=controls(form);
      if (!buttons.length) return;
      var session={form:form,buttons:buttons,started:Date.now(),finished:false,requestObserved:false,timer:null};
      current=session;
      buttons.forEach(function (button) {
        button.classList.remove('mm-atc-error','mm-button-tap-pulse');
        status(button).textContent='ADDING TO BAG...';
        button.classList.add('mm-atc-pending');
        button.setAttribute('aria-busy','true');
      });
      // A safety fallback, never interpreted as confirmed success.
      session.timer=setTimeout(function () { settle(false,'CHECK YOUR BAG / TRY AGAIN'); },15000);
    }
    function reset(session) {
      if (current !== session) return;
      clearTimeout(session.timer);
      session.buttons.forEach(function (button) {
        button.classList.remove('mm-atc-pending','mm-atc-error','mm-button-tap-pulse');
        button.removeAttribute('aria-busy');
      });
      current=null;
    }
    function settle(ok, message) {
      var session=current;
      if (!session || session.finished || !session.requestObserved) return;
      session.finished=true;
      clearTimeout(session.timer);
      // Ensure the animation is perceivable when Shopify responds very quickly.
      var remaining=Math.max(0,650-(Date.now()-session.started));
      setTimeout(function () {
        if(current!==session) return;
        if(ok) { reset(session); return; }
        session.buttons.forEach(function (button) {
          button.classList.remove('mm-atc-pending');
          button.classList.add('mm-atc-error');
          button.removeAttribute('aria-busy');
          status(button).textContent=message||'UNABLE TO ADD TO BAG';
        });
        setTimeout(function () { reset(session); },1200);
      },remaining);
    }
    function failWithoutResponse() {
      if(!current || current.finished) return;
      current.requestObserved=true;
      settle(false,'PLEASE CHECK YOUR BAG');
    }

    // Read network completion without consuming/changing the response body.
    if(typeof originalFetch==='function') {
      window.fetch=function () {
        var args=arguments;
        var method=(args[1] && args[1].method) || (args[0] && args[0].method) || 'GET';
        var tracked=!!current && cartAddUrl(args[0]) && String(method).toUpperCase()==='POST';
        if(tracked) current.requestObserved=true;
        var p=originalFetch.apply(this,args);
        if(!tracked) return p;
        return p.then(function(response) {
          settle(response.ok);
          return response;
        },function(error) {
          settle(false);
          throw error;
        });
      };
    }
    window.XMLHttpRequest.prototype.open=function () {
      this.__mmCartAddRequest=cartAddUrl(arguments[1]) && String(arguments[0]).toUpperCase()==='POST';
      return originalOpen.apply(this,arguments);
    };
    window.XMLHttpRequest.prototype.send=function () {
      if(this.__mmCartAddRequest && current) {
        current.requestObserved=true;
        this.addEventListener('loadend',function () {
          settle(this.status>=200 && this.status<300);
        },{once:true});
      }
      return originalSend.apply(this,arguments);
    };

    function formFor(button) {
      var form=button.closest('form[data-type="add-to-cart-form"]');
      if(form) return form;
      var wrapper=button.closest('.t4s-product-form__variants');
      return wrapper && wrapper.querySelector('form[data-type="add-to-cart-form"]');
    }
    document.addEventListener('click',function(event){
      var target=event.target;
      if(!target || !target.closest) return;
      var button=target.closest('button[data-atc-form].t4s-product-form__submit, .mm-mobile-sticky-atc button');
      if(!button) return;
      if(current) {
        // Let sticky ATC forward its programmatic click to the genuine submit button.
        if(event.isTrusted) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
        return;
      }
      var form=formFor(button);
      if(form && enabled(form)) start(form);
    },true);
    document.addEventListener('submit',function(event) {
      var form=event.target;
      if(form && form.matches('form[data-type="add-to-cart-form"]') && !current && enabled(form)) start(form);
    },false);
  }
})();
